import classNames from 'clsx';
import React from 'react';
import IconFacebook from '~/components/svg/icon-facebook.svg';
import IconTwitter from '~/components/svg/icon-twitter.svg';
import IconPinterest from '~/components/svg/icon-pinterest.svg';

import Config, { keyConfig } from '~/config';
import { slugs } from '~/utils';

const SHARE_SERVICE = {
  FACEBOOK: 'facebook',
  TWITTER: 'twitter',
  PINTEREST: 'pinterest',
};
const shareServiceIcons = {
  [SHARE_SERVICE.FACEBOOK]: <IconFacebook />,
  [SHARE_SERVICE.TWITTER]: <IconTwitter />,
  [SHARE_SERVICE.PINTEREST]: <IconPinterest />,
};
const socialBaseUrls = {
  [SHARE_SERVICE.FACEBOOK]: 'https://facebook.com/sharer/sharer.php?u=',
  [SHARE_SERVICE.TWITTER]: 'https://twitter.com/intent/tweet/?text=&url=',
  [SHARE_SERVICE.PINTEREST]: 'https://www.pinterest.com/pin-builder/?url=',
};

class ButtonSocialShare extends React.Component {
  onSocialShare = (serviceName) => {
    const socialBaseUrl = socialBaseUrls[serviceName];
    const { lng, photo } = this.props;
    console.log('lngggggggg', lng);
    const photoTitle = Config.getTitleByLanguage(photo.title, lng);
    const slugTitle = slugs.makeSlug(photoTitle, {
      lang: lng,
    });

    const { protocol, host } = window.location;
    // let imageUrl = `${protocol}//${host}`;
    // imageUrl = imageUrl + `/${lng}`;
    let imageUrl = `${Config.getSiteURL()}/${keyConfig.get(
      'route_detail_page',
    )}/${photo.id}/${slugTitle}`;
    const shareUrl = `${socialBaseUrl}${imageUrl}`;

    window.open(
      shareUrl,
      'share',
      `height=450, width=550, top=${window.innerHeight / 2 - 275}, left=${
        window.innerWidth / 2 - 225
      }, toolbar=0, location=0, menubar=0, directories=0, scrollbars=0`,
    );
  };

  handleClickPinterest = () => {
    const { description, photo } = this.props;
    let imageUrl = photo.path;
    /* eslint-disable */
    PinUtils.pinOne({
      url: window.location.href,
      media: imageUrl,
      description: description,
    });
  };

  noPropagation = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  render() {
    const shareActions = [
      SHARE_SERVICE.PINTEREST,
      SHARE_SERVICE.TWITTER,
      SHARE_SERVICE.FACEBOOK,
    ].map((serviceName) => {
      const shareButtonClassName = classNames(
        'share-button',
        `btn-${serviceName}`,
      );
      return (
        <div
          key={serviceName}
          className={shareButtonClassName}
          onClick={(e) => {
            this.noPropagation(e);
            if (serviceName === SHARE_SERVICE.PINTEREST) {
              this.handleClickPinterest();
            } else {
              this.onSocialShare(serviceName);
            }
          }}
        >
          {shareServiceIcons[serviceName]}
          <span className="name-social">{serviceName}</span>
          <style jsx>
            {`
              .share-button {
                display: flex;
                justify-content: center;
                flex-direction: row;
                align-items: center;
                cursor: pointer;
              }
              .share-button.btn-twitter {
                width: 100px;
                height: 44px;
                background: #55acee;
                border-radius: 4px;
                padding: 0;
                display: flex;
              }
              .share-button.btn-facebook {
                width: 116px;
                height: 44px;
                background: #1877f2;
                border-radius: 4px;
                padding: 0;
                display: flex;
              }
              .share-button.btn-pinterest {
                width: 116px;
                height: 44px;
                background: #e40425;
                border-radius: 4px;
                padding: 0;
                display: flex;
              }
              .name-social {
                font-weight: bold;
                font-size: 16px;
                color: #f8f9fa;
                margin-left: 4px;
                text-transform: capitalize;
              }
            `}
          </style>
        </div>
      );
    });

    return (
      <div className="container-action-social">
        {shareActions}
        <style jsx>
          {`
            .container-action-social {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              margin-top: 8px;
              width: 350px;
            }
          `}
        </style>
      </div>
    );
  }
}

export default ButtonSocialShare;
